import { MemoriesItem } from '@presentationTypes';

export const memoriesItems: MemoriesItem[] = [
  {
    img: '/images/concert.png',
    descKey: 'memories.concert_desc',
    labelKey: 'memories.concert',
  },
  {
    img: '/images/interview.png',
    descKey: 'memories.interview_desc',
    labelKey: 'memories.interview',
  },
  {
    img: '/images/community.png',
    descKey: 'memories.community_desc',
    labelKey: 'memories.community',
  },
  {
    img: '/images/foosball.png',
    descKey: 'memories.foosball_desc',
    labelKey: 'memories.foosball',
  },
  {
    img: '/images/workshop.png',
    descKey: 'memories.workshop_desc',
    labelKey: 'memories.workshop',
  },
  {
    img: '/images/live_broadcasts.png',
    descKey: 'memories.live_broadcasts_desc',
    labelKey: 'memories.live_broadcasts',
  },
  {
    img: '/images/theme_night.png',
    descKey: 'memories.theme_night_desc',
    labelKey: 'memories.theme_night',
  },
  {
    img: '/images/debate.png',
    descKey: 'memories.debate_desc',
    labelKey: 'memories.debate',
  },
];
